/* eslint-disable */
// 通联会员

import request, {Method} from '@/utils/request'

// 校验会员是否可以支付
export function isCheck(params) {
  return request({
    url: `/memberstongv2/isCheck`,
    method: Method.GET,
    needToken: true,
    params
  })
}

// 开通账户
export function openUser(data) {
  return request({
    url: `/memberstongv2/openUser`,
    method: Method.PUT,
    needToken: true,
    data
  })
}

// 开通账户-发送验证码
export function openUserSendPhone(data) {
  return request({
    url: `/memberstongv2/openUserSendPhone`,
    method: Method.PUT,
    needToken: true,
    data
  })
}

// 获取通联支付二维码 - 订单
export function getPayQrCode(params) {
  return request({
    url: `/tong/pay/${params.trade_type}/${params.sn}`,
    method: Method.GET,
    needToken: true,
    params: {
      pay_mode: params.pay_mode,
      payment_plugin_id: params.payment_plugin_id,
      client_type: params.client_type
    }
  })
}
// 获取通联支付二维码 -- 充值

export function getPayQrCodeRecharge(params) {
  return request({
    url: `/tong/recharge/${params.sn}`,
    method: Method.POST,
    needToken: true,
    params: {
      pay_mode: params.pay_mode,
      payment_plugin_id: params.payment_plugin_id,
      client_type: params.client_type,
       sn: params.sn
    }
  })
}

//实名认证
export function setRealName(data) {
  return request({
    url: `/memberstongv2/setRealName`,
    headers: {
      'Content-Type': 'application/json',
    },
    method: Method.POST,
    needToken: true,
    is_json: true,
    data
  })
}


//绑定银行卡
export function applyBindBankCard(data) {
  return request({
    url: `/memberstongv2/applyBindBankCard`,
    headers: {
      'Content-Type': 'application/json',
    },
    method: Method.POST,
    needToken: true,
    is_json: true,
    data
  })
}

//确认绑定银行卡
export function bindBankCard(data) {
  return request({
    url: `/memberstongv2/bindBankCard`,
    headers: {
      'Content-Type': 'application/json',
    },
    method: Method.POST,
    needToken: true,
    is_json: true,
    data
  })
}
// 签订合约

export function signContract(data) {
  return request({
    url: `/memberstongv2/signContract`,
    method: Method.PUT,
    needToken: true,
    data
  })
}


//签约状态

export function signContractStatus(data) {
  return request({
    url: `/memberstongv2/signContractStatus`,
    method: Method.PUT,
    needToken: true,
    data
  })
}
// 查询支付结果 V2
export function getPayStatus(trade_type, sn, params) {
  return request({
    url: `/payment/order/pay/queryV2/${trade_type}/${sn}`,
    method: Method.GET,
    needToken: true,
    loading: false,
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/userMember.js